<template>
    <form>
        <div class="alert alert-warning" role="alert">
        <b>Notice:</b> When assigning multiple day schedules, you WILL experience strange behavior if any bells overlap (time and device). The system will not notify you of any overlap.
        </div>
        <div class="form-group">
        <label for="ddlDaySchedule">Exception Schedule(s)</label>
        <v-select
            multiple
            placeholder="Select..."
            v-model="exception_data.selected_day_schedules"
            v-on:input="exception_schedules_changed"
            :options="filtered_day_schedules_for_drop_down"
        ></v-select>
        </div>
        <label for="ddlExceptionType">Type</label>
        <div class="form-group">
        <select class="form-control" id="ddlExceptionType" v-model="exception_data.exception_type">
            <option value="1">Overwrite</option>
            <option value="2">Append</option>
        </select>
        </div>
        <button type="button" class="btn btn-hub-primary" @click="submit()">Submit</button>
        <button type="button" class="btn btn-secondary" v-if="callback" @click="callback('cancel')">Cancel</button>
        <router-link :to="{ name: 'CalendarScheduler' }" class="btn btn-secondary" v-else>Cancel</router-link>
    </form>
</template>

<script>
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
    props: {
        date: String,
        callback: Function
    },
    components: { vSelect },
    data: function () {
        return {
            exception_data: {
                start_date: this.date,
                end_date: this.date,
                selected_day_schedules: [],
                exception_type: 1
            }
        }
    },
    computed: {
        ...mapGetters({
            calendar_exception_data_for_date: 'calendarExceptionDataForDate',
            day_schedules: 'allDaySchedules',
            scoped_site_id: 'scopedSiteId'
        }),
        filtered_day_schedules_for_drop_down: function () {
            let temp = this.day_schedules
                .filter((daySchedule) => daySchedule.site_id === this.scoped_site_id)
                .map((daySchedule) => {
                    return {
                        value: daySchedule.day_schedule_id,
                        label: daySchedule.name
                    }
                })

            temp.push({
                value: 0,
                label: 'No Bells'
            })

            return temp
        }
    },
    watch: {
        calendar_exception_data_for_date(newValue, oldValue) {
            let self = this

            for (let i = 0; i < newValue.day_schedule_ids.length; i++) {
                this.exception_data.selected_day_schedules.push({
                    value: newValue.day_schedule_ids[i],
                    label: self.filtered_day_schedules_for_drop_down.find(ds => ds.value === newValue.day_schedule_ids[i]).label
                })
            }

            this.exception_data.exception_type = newValue.exception_type
        }
    },
    created() {
        this.$store.dispatch('setDisabledChangeScopedSite', true)
        this.$store.dispatch('getDaySchedules')
        this.$store.dispatch('getCalendarExceptionDataForDate', this.date)
    },
    methods: {
        exception_schedules_changed() {
            let hasNoBells = false

            for (let i = 0; i < this.exception_data.selected_day_schedules.length; i++) {
                if (this.exception_data.selected_day_schedules[i].value === 0) {
                    hasNoBells = true
                    break
                }
            }

            if (hasNoBells) {
                this.exception_data.selected_day_schedules = [{
                    value: 0,
                    label: 'No Bells'
                }]
                this.exception_data.exception_type = 1
                /* eslint-disable-next-line */
                $('#ddlExceptionType').prop('disabled', true)
            } else {
                /* eslint-disable-next-line */
                $('#ddlExceptionType').prop('disabled', false)
            }
        },
        submit() {
            this.exception_data.push_on_success = this.callback ? false : 'CalendarScheduler'
            this.$store.dispatch('modifyExceptionRange', this.exception_data).then(() => {
                if(this.callback) 
                    this.callback('success')
            })
        }
    }
}
</script>